export const DEFAULT_LEGACY_APPSYNC_GRAPHQL_ENDPOINT =
  'https://testing-api.onesimplicity.com/graphql';
export const ENDPOINT_NAME = 'legacy appsync';
export const ANNOUNCEMENTS_PAGE_SIZE = 10;
export const EVENTS_PAGE_SIZE = 10;
export const BUSINESS_NOTIFICATIONS_PAGE_SIZE = 10;
